import styled from 'styled-components';
import { Button } from '@terrainvest/react-components';

export const StyledButton = styled(Button)`
    height: 40px;
    margin: 16px 0;
`;
